import styled from 'styled-components';

export const MktVipPassTicketsWrapper = styled.div`
  /* Apply text-indent: 0 to all content within tickets for this page only to not affect other pages*/
  * {
    text-indent: 0 !important;
  }
`;
